import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import { CandidateLink } from 'domain/shared/candidate';
import { TextField } from 'framework/ui/field';
import { ContactFieldBase } from 'framework/ui/layout';

export const CandidateDuplicateOfField = ({
  duplicateOfId,
  duplicateFullName,
}: {
  duplicateOfId: StringOrNumber;
  duplicateFullName: string;
}) => {
  const icon = <SupervisorAccountOutlinedIcon fontSize="medium" sx={{ color: '--var-palete-primary-main' }} />;
  const content = <TextField label="" value={<CandidateLink id={duplicateOfId} name={duplicateFullName} />} />;

  return <ContactFieldBase key={duplicateOfId} icon={icon} content={content} />;
};
